import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import Label from '../../../components/label/Label';

export default function UserReqTable({ rowData }) {
  return (
    <TableContainer component={Paper}>
      <Table  aria-label="spanning table">
        <TableHead>
       
        </TableHead>
        <TableBody>
          
          <TableRow>
            <TableCell>User Name</TableCell>
            <TableCell  align="right">{rowData.user.name}</TableCell>
          </TableRow>


          <TableRow>
            <TableCell>Request Number</TableCell>
            <TableCell align="right">{rowData._id}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Request {rowData.status} Date</TableCell>
            <TableCell align="right">{moment(rowData?.request_accept_date).format('DD-MM-YYYY')}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Request Date</TableCell>
            <TableCell align="right">{moment(rowData.createdAt).format('DD-MM-YYYY')}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Payment Method</TableCell>
            <TableCell align="right">
              <Label color={'success'}>{rowData.payment_method}</Label>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Request Points</TableCell>
            <TableCell align="right">{rowData.request_points}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
